import { Component, OnInit } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

import { BreadcrumbLink } from '../../../../shared/interfaces/breadcrumb-link.interface'
import { Faq } from '../../../../shared/interfaces/faq.interface'
import { Page } from '../../../../shared/interfaces/page.interface'
import { StripHtmlPipe } from '../../../../shared/pipes/strip-html.pipe'
import { BreadcrumbService } from '../../../../shared/services/breadcrumb.service'
import { FaqService } from '../../../../shared/services/faq.service'
import { MetaService } from '../../../../shared/services/meta.service'
import { PageService } from '../../../../shared/services/page-service/page.service'

@Component({
  selector: 'app-tools-catalogue-faq',
  templateUrl: './tools-catalogue-faq.component.html',
  styleUrls: ['./tools-catalogue-faq.component.scss']
})
export class ToolsCatalogueFaqComponent implements OnInit {
  faqs: Faq[]
  faqContent: Page
  faqContentSafeHtml: SafeHtml
  breadcrumbLinks: BreadcrumbLink[]

  toolFaqCategorySlug = 'tool-faq'

  constructor(
    private faqService: FaqService,
    private metaService: MetaService,
    private stripHtmlPipe: StripHtmlPipe,
    private pageService: PageService,
    private breadcrumbService: BreadcrumbService,
    private sanitizer: DomSanitizer
  ) {}

  async ngOnInit() {
    this.breadcrumbLinks = this.breadcrumbService.getBreadCrumbLinks(
      'toolCatalog',
      [
        {
          label: 'About the catalogue'
        }
      ]
    )

    this.faqService
      .list({ faqCategorySlug: this.toolFaqCategorySlug })
      .then((resFaq: Faq[]) => (this.faqs = resFaq))

    this.faqContent = await this.pageService.show('tools-faq')

    this.faqContentSafeHtml = this.sanitizer.bypassSecurityTrustHtml(
      this.faqContent.content
    )

    this.metaService.setTags({
      title: this.faqContent.metaTitle || this.faqContent.title,
      description: this.stripHtmlPipe.transform(
        this.faqContent.metaDescription || this.faqContent.excerpt
      ),
      path: 'tools-catalogue/faq',
      absoluteOgImage: this.faqContent.image
        ? this.faqContent.image.socialCard ||
          this.faqContent.image.landscape ||
          this.faqContent.image.videoCard
        : this.metaService.defaultMeta.absoluteOgImage
    })
  }
}
